import axios from "axios";
import * as ActionType from "./paymentHistory.type";
import { setToast } from "../../util/toast";
import { apiInstanceFetch } from "../../util/api";
import { apiInstance } from "../../util/api-new";

// Get Payment History
export const getPaymentHistory =
  (page, limit, startDate, endDate) => (dispatch) => {
    apiInstanceFetch
      .get(
        `admin/payment/history?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`,
      )
      .then((res) => {
        dispatch({
          type: ActionType.GET_PAYMENT_HISTORY,
          payload: {
            paymentHistory: res.data.payments,
            totalPaymentHistory: res.data.total,
          },
        });
      })
      .catch((error) => console.error(error));
  };

// Get Payment History
export const getOrgPaymentHistory =
  (page, limit, startDate = "All", endDate = "All") =>
  (dispatch) => {
    apiInstance
      .get(
        `organization/payment/history?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`,
      )
      .then((res) => {
        dispatch({
          type: ActionType.GET_PAYMENT_HISTORY,
          payload: {
            paymentHistory: res.data.payments,
            totalPaymentHistory: res.data.total,
          },
        });
      })
      .catch((error) => console.error(error));
  };
